import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import {
  DELETE_PRODUCTION_DECLARATION_DOCUMENT_KEY,
  GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGIN_DOCUMENTS_KEY,
} from '@/keys';

type DeleteProductionDeclarationDocumentVariables = {
  productionDeclarationId: string;
  materialId: string;
  commodityOriginId: string;
  documentId: string;
  token?: string;
};

async function deleteProductionDeclarationDocument({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  documentId,
  token,
}: DeleteProductionDeclarationDocumentVariables): Promise<void> {
  await api.delete(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/documents/${documentId}`,
    {
      params: token ? { token } : undefined,
    },
  );
}

export function useDeleteProductionDeclarationDocument(): UseMutationResult<
  void,
  Error,
  DeleteProductionDeclarationDocumentVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: DELETE_PRODUCTION_DECLARATION_DOCUMENT_KEY,
    mutationFn: deleteProductionDeclarationDocument,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          ...GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGIN_DOCUMENTS_KEY,
          variables.productionDeclarationId,
          variables.materialId,
          variables.commodityOriginId,
          variables.token ?? '',
        ],
      });
    },
  });
}
